import { IUnitTestProps } from '@monorepo/client-types';
import { AffiliateCommissionStatus, PayoutStatus } from '@monorepo/types';

export const TABLE_KEY = 'affiliatePortal.tableHeaders';

export interface FilterStateManagement {
  onSearch: (value: string, key: string) => void;
  filterSearchInputState?: FilterSearchInputState;
  setFilterSearchInputState?: (newState: FilterSearchInputState) => void;
}

export interface TableContentProps extends IUnitTestProps {
  tabType: TransactionTabType;
}

// Enum for transaction tab types
export enum TransactionTabType {
  COMMISSIONS = 'commissions',
  HISTORY = 'history',
}

// Enum for analytics tab types
export enum AnalyticsTabType {
  CLICKS = 'clicks',
  REGISTRATION = 'registration',
  CTR = 'ctr',
}

export type StatusArray = PayoutStatus[] | AffiliateCommissionStatus[];

export type Filters = {
  status?: StatusArray;
  [key: string]: any;
};

export type FilterSearchInputState = Record<string, React.Key[]>;

export interface TransactionData<T> {
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
  totalItems: number;
  page: number;
  limit: number;
  setPage: (page: number) => void;
  refetch: () => void;
  data: T[];
}
